<template>
  <div class="trunk">
    <div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="lb-panel lb-img1"></div>
          <div class="lb-back">{{ $t('content.home.topTitle') }}</div>
        </swiper-slide>
        <swiper-slide>
          <div class="lb-panel lb-img2"></div>
          <div class="lb-back">{{ $t('content.home.topTitle') }}</div>
        </swiper-slide>
        <swiper-slide>
          <div class="lb-panel lb-img3"></div>
          <div class="lb-back">{{ $t('content.home.topTitle') }}</div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="f1">
      <!-- <div class="left source"><span>{{ $t('content.home.about') }}</span></div> -->
      <div class="right">
        <div class="panel">
          <div class="item1">PURE HAPPINESS</div>
          <div class="item1">FROM DENMARK</div>
          <div class="item2">REFINE / RELAX / COOL</div>
        </div>
      </div>
    </div>
    <div class="f3">
      <div class="h-panel">
        <div class="item1">{{ $t('content.home.panel[0][0]') }}</div>
        <div class="item1">{{ $t('content.home.panel[0][1]') }}</div>
        <div class="item1" style="margin-bottom: 50px;">{{ $t('content.home.panel[0][2]') }}</div>
        <div class="item2">{{ $t('content.home.panel[0][3]') }}</div>
        <div class="item2">{{ $t('content.home.panel[0][4]') }}</div>
        <div class="item2">{{ $t('content.home.panel[0][5]') }}</div>
        <div class="item3">
          <router-link to="/design" class="a-btn"> {{ $t('content.home.panel[0][5]') }}</router-link>
        </div>
      </div>
      <div class="back"></div>
    </div>
    <div class="f4">
      <img class="left" src="../assets/images/store.png">
      <div class="right ">
        <div class="h-panel">
          <div class="item1">{{ $t('content.home.panel[1][0]') }}</div>
          <div class="item1">{{ $t('content.home.panel[1][1]') }}</div>
          <div class="item2">{{ $t('content.home.panel[1][2]') }}</div>
          <div class="item2">{{ $t('content.home.panel[1][3]') }}</div>
          <div class="item2">{{ $t('content.home.panel[1][4]') }}</div>
          <div class="item3">
            <router-link to="/contact" class="a-btn"> {{ $t('content.home.panel[1][5]') }}</router-link>
          </div>
        </div>

      </div>
    </div>
    <div class="f5-p leftOfRight">
      <div class="content">
        <div class="panel">
          <div class="title" style="font-size: 52px;">
            {{ $t('content.home.content[0][0]') }}
          </div>
          <div class="detail" style="font-size: 18px;">
            {{ $t('content.home.content[0][1]') }}<br>
            {{ $t('content.home.content[0][2]') }}<br>
            {{ $t('content.home.content[0][3]') }}<br>
          </div>
        </div>
      </div>
      <div class="img-back">
        <img src="../assets/images/nest04.png">
      </div>
    </div>
    <div class="f5-m leftOfRight">
      <div class="img-back">
        <img src="../assets/images/nest04.png">
      </div>
      <div class="content">
        <div class="panel">
          <div class="title">
            {{ $t('content.home.content[0][0]') }}
          </div>
          <div class="detail">
            {{ $t('content.home.content[0][1]') }}<br>
            {{ $t('content.home.content[0][2]') }}<br>
            {{ $t('content.home.content[0][3]') }}<br>
          </div>
        </div>
      </div>
    </div>
    <div class="f6 leftOfRight">
      <div class="img-back">
        <img src="../assets/images/nest05.png">
      </div>
      <div class="content">
        <div class="panel">
          <div class="title" style="font-size: 52px;">
            {{ $t('content.home.content[1][0]') }}
          </div>
          <div class="detail" style="font-size: 18px;">
            {{ $t('content.home.content[1][1]') }}<br>
            {{ $t('content.home.content[1][2]') }}<br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.swiper-container-list2 {
  overflow: visible;
}

.swiper-pagination-bullet {
  width: 35px;
  height: 4px;
  border-radius: 0;
  background-color: #fff;
  opacity: 0.3;
}

.swiper-pagination-bullet-active {
  background: #fff;
  opacity: 1;
}
</style>
<style scoped lang="less">
.trunk {}

.lb-panel {
  width: 100%;
  height: 100vh;
  text-align: center;
  color: #fff;
  padding-top: 120px;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  z-index: 1;
}

.lb-img1 {
  background-image: url('../assets/images/header01.png');
}

.lb-img2 {
  background-image: url('../assets/images/header02.jpg');
}

.lb-img3 {
  background-image: url('../assets/images/header03.jpg');
}

.lb-back {
  background-color: rgba(0, 0, 0, .5);
  position: absolute;
  z-index: 5;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 3.6vw;
}

.h-panel {
  color: #ffffff;

  .item1 {
    font-size: 52px;
    margin-bottom: 10px;
  }

  .item2 {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .item3 {
    margin-top: 50px;
  }
}

.f1 {
  background-image: linear-gradient(to right, #fff, #D9D7D4);
  width: 100%;
  height: 400px;
  margin-top: 60px;
  position: relative;
  z-index: 1;

  .left {
    position: absolute;
    z-index: 2;
    left: 10%;
    top: 100px;
    border-left: 4px solid #323232;
    color: #323232;
    padding-left: 30px;
    font-size: 24px;

  }

  .right {
    text-align: center;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    // border: 1px solid red;

    .panel {
      width: 100%;

      .item1 {
        font-size: 3.6vw;
        font-weight: bold;
      }

      .item2 {
        font-size: 18px;
        font-weight: bold;
      }
    }

  }
}

// .f2 {
//   color: #fff;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding: 80px 0;
//   column-gap: 50px;
//   row-gap: 30px;
//   flex-wrap: wrap;
//   background-color: #C4C0BD;
//   margin-bottom: 80px;
//   position: relative;
//   z-index: 1;

//   .panel {
//     display: block;
//     transition: 0.5s;
//     position: relative;
//     z-index: 2;

//     .img1 {
//       display: block;
//       width: 300px;
//       height: auto;
//       margin-bottom: 35px;
//       border-radius: 5px;
//     }

//     .title {
//       font-size: 38px;
//       margin-bottom: 20px;
//     }

//     .detail {
//       font-size: 14px;
//       margin-bottom: 20px;
//     }

//     .img2 {
//       display: block;
//       width: 28px;
//       height: auto;
//       cursor: pointer;
//     }

//     .img3 {
//       width: 70%;
//       position: absolute;
//       right: 0;
//       bottom: 40px;
//       z-index: 4;
//     }
//   }

//   .panel:hover {
//     opacity: 0.8;
//   }
// }

.f3 {
  height: 100vh;
  text-align: center;
  // color: #fff;
  padding-top: 120px;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  z-index: 1;
  background-image: url('../assets/images/desc.png');
  display: flex;
  justify-content: left;
  align-items: center;

  .back {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 5;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .23)
  }

  .h-panel {
    position: absolute;
    z-index: 8;
    color: #ffffff;
    margin-left: 20%;
  }
}

.f4 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: linear-gradient(180.00deg, rgb(102, 97, 96), rgb(236, 236, 236) 100%);

  .left {
    width: 50%;
  }

  .right {
    .h-panel {
      text-align: center;
    }

    width: 50%;
    float: left;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.f5-p,.f5-m,.f6{
  background: linear-gradient(180.00deg, rgb(102, 97, 96), rgb(236, 236, 236) 100%);
  .content {
    .panel{
      color: #ffffff;

      .detail{
        color: #ffffff;
      }
    }
  }
}

@media (max-width:600px) {
  .f5-p{
    display: none;
  }
  .leftOfRight{
    background: linear-gradient(180.00deg, rgb(102, 97, 96), rgb(236, 236, 236) 100%);
    .content {
      .panel {
        .title{
          font-size: 32px;
          font-weight: 200;
        }
        .detail{
          font-size: 16px;
        }
      }
    }
  }
  .h-panel {
    .item1 {
      font-size: 32px;
      // margin-bottom: 10px;
    }

    .item2 {
      font-size: 16px;
      // margin-bottom: 10px;
    }

    .item3 {
      font-size: 12px;
      // margin-top: 50px;
    }
  }

  // .f2 {
  //   .panel {
  //     .img1 {
  //       width: 100%;
  //     }
  //   }
  // }

  .f3 {
    .h-panel {
      // position: relative;
      margin: auto;
      left: 0;
      top: 10%;
      width: 100%;
      // color: #000000;
    }
  }

  .f4 {
    .left {
      width: 100%;
    }

    ;

    .right {
      width: 100%;
      height: 500px;
      padding: 50px 20px;
    }
  }
}
@media (min-width:600px){
  .f5-m{
    display: none;
  }
}
</style>
<script>

import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getQrCode } from '../utils/api';

export default {
  name: 'HomeSwiper',
  components: {
    swiper,
    swiperSlide
  },

  data() {
    return {
      swiperOption: {
        loop: true,//可选选项，开启循环
        autoplay: true,//可选选项，自动滑动
        pagination: {
          el: '.swiper-pagination',
          // bulletActiveClass: 'my-bullet-active',
        },
        paginationType: 'fraction',
        paginationClickable: true,
      },
      swiperOption2: {
        slidesPerView: 3,
        spaceBetween: 50,
        grabCursor: true,
        paginationClickable: true,
      },
      player: null, // 用来存储当前 video
      videoOpenInti: false,
      listShow: [false, false, false, false],
      language: localStorage.getItem("lang") || "zh"
    };
  },
  mounted() {

  },
  created() {

  },
  methods: {
    handleMouseEnter(index) {
      this.listShow.splice(index, 1, true);
    },
    handleMouseLeave(index) {
      this.listShow = [false, false, false, false];
    },
    btn_product(type) {
      this.$router.push({
        path: '/product',  // 直接使用路径
        query: {
          type: type
        }
      });
    }
  }
}
</script>